<nav class="">
  <div class="navbar-wrapper">
    <div class="m-header">
      <a (click)="returnHome()" class="b-brand">
        @if (themeMode === 'compact') {
          <img src="assets/images/velo-admin-logo.png" alt="small-menu-logo" class="logo logo-sm" />
        } @else {
          <img src="assets/images/velo-full-logo.png" alt="logo" class="logo logo-lg" />
        }
      </a>
    </div>
    <app-nav-content
      (NavCollapsedMob)="navCollapseMob()"
      (SubmenuCollapse)="navSubmenuCollapse()"
      class="scroll-div w-100 compact"
    ></app-nav-content>
    <div class="sidebar-footer">
      <a href="javascript:" class="sidebar-toggle-btn" (click)="toggleSidebarLayout()" title="Toggle Sidebar">
        <i class="ti ti-menu-2"></i>
      </a>
    </div>
  </div>
</nav>
